// extracted by mini-css-extract-plugin
export default {"root":"EvacxtBoKUcsSrldzQqQ","marker":"JfI09MAXZluRTZVtQvb4","item":"GAhX3sbvi6wvDpiqCEog","item--line-variant-dashed":"Ceatoai7myiwfKFTJwsk"};